import { updateObject } from '../../shared/utility';
import { RESET_PASSWORD_START, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAIL, CLEAR_RESET, OPEN_RESET_FORM, CLOSE_RESET_FORM} from '../actions/actionTypes';


const initialState = {
    error: null,
    message:null,
    loading: false,
    resetId:null,
    visibleResetForm:false,
}

const resetPasswordStart=(state,action)=>{
    return updateObject(state,{error:null,loading:true});
}

const resetPasswordSuccess=(state,action)=>{
    return updateObject(state,{error:null,message:action.message,loading:false});
}

const resetPasswordFail=(state,action)=>{
    return updateObject(state,{error:action.error,loading:false});
}

const clearReset=(state,action)=>{
    return updateObject(state,{error:null,message:null});
}

const openResetForm=(state,action)=>{
    return updateObject(state,{resetId:action.id,visibleResetForm:true});
}

const closeResetForm=(state,action)=>{
    return updateObject(state,{resetId:null,visibleResetForm:false});
}
const resetPasswordReducer=(state=initialState,action)=>{
    switch (action.type) {
        case RESET_PASSWORD_START:
            return resetPasswordStart(state,action);
        case RESET_PASSWORD_SUCCESS:
            return resetPasswordSuccess(state,action);
        case RESET_PASSWORD_FAIL:
            return resetPasswordFail(state,action);
        case CLEAR_RESET:
            return clearReset(state,action);
        case OPEN_RESET_FORM:
            return openResetForm(state,action);
        case CLOSE_RESET_FORM:
            return closeResetForm(state,action);
        default:
            return state;
    }
}

export default resetPasswordReducer;